export default __webpack_public_path__ + "static/media/folders.df82e6db.svg";